import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as o } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const i = o((s, a) => /* @__PURE__ */ e.jsx(
  r,
  {
    ref: a,
    ...s,
    image: (l) => /* @__PURE__ */ e.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...l,
        children: [
          /* @__PURE__ */ e.jsx(
            "mask",
            {
              id: "mask0_2974_3544",
              width: 10,
              height: 16,
              x: 3,
              y: 0,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ e.jsx(
                "path",
                {
                  fill: "currentColor",
                  fillRule: "evenodd",
                  d: "M4.56 0a.96.96 0 0 0-.96.96v14.08a.96.96 0 0 0 1.92 0V.96A.96.96 0 0 0 4.56 0m6.859 0a.96.96 0 0 0-.96.96v14.08a.96.96 0 0 0 1.92 0V.96a.96.96 0 0 0-.96-.96",
                  clipRule: "evenodd"
                }
              )
            }
          ),
          /* @__PURE__ */ e.jsx("g", { mask: "url(#mask0_2974_3544)", children: /* @__PURE__ */ e.jsx("path", { fill: "currentColor", d: "M-.4 0h16v16h-16z" }) })
        ]
      }
    )
  }
));
i.displayName = "AgencyPauseIcon";
export {
  i as AgencyPauseIcon,
  i as default
};
//# sourceMappingURL=index.js.map
